// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* On air = red tally, not the generic \"enabled\" green. */\n.graphic-switch[data-v-acb3669a] .switcher:checked::before {\n\tbackground-color: var(--error);\n}\n/* Staged, not on Program yet: the draft colour, like the unsaved-changes dot. */\n.graphic-switch--pending[data-v-acb3669a] .switcher:checked::before {\n\tbackground-color: var(--gold-custom);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
